import React from "react";
import UserProfile from "../components/AuthPages/UserProfile";

export default function UserProfilePage() {
  return <UserProfile />;
}
